import { defineEntity, custom } from './_helpers.js';

export default defineEntity('collectionAssignment', {
    assigned: custom({ scope: 'state' }),
    completed: custom({ scope: 'state' }),
    cancelled: custom({ scope: 'state' }),
    reopened: custom({ scope: 'state' }),
    reminded: custom({ scope: 'state' }),
    deadlineWarning: custom({ scope: 'state' }),
    overdue: custom({ scope: 'state' }),
}, { includeDefaultLifecycle: false });
